import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['modal', 'overlay', 'modalImage', 'thumbnail']

  connect = () => {
    document.addEventListener('keydown', this.handleKeyDown)
  }

  disconnect = () => {
    document.removeEventListener('keydown', this.handleKeyDown)
  }

  open = (event) => {
    const imageUrl = event.currentTarget.src
    this.modalImageTarget.src = imageUrl
    this.modalTarget.classList.remove('hidden')
    this.overlayTarget.classList.remove('hidden')
    document.body.classList.add('overflow-hidden')
  }

  close = () => {
    this.modalTarget.classList.add('hidden')
    this.overlayTarget.classList.add('hidden')
    document.body.classList.remove('overflow-hidden')
  }

  closeOnBackdrop = (event) => {
    if (event.target === event.currentTarget) {
      this.close()
    }
  }

  handleKeyDown = (event) => {
    if (event.key === 'Escape' && !this.modalTarget.classList.contains('hidden')) {
      this.close()
    }
  }
}
